function MobileModalShare(config) {
  this.config = config
  this.shareTracker = new slideshare_object.ShareTracker()
  this.init()
}

MobileModalShare.prototype = {}

MobileModalShare.prototype.IOS4REGEX = /["iPhone"|"iPad"].+i?OS [4|3].+Safari/

MobileModalShare.prototype.isIpadAndChrome = function () {
  return /ipad.*crios|crios.*ipad|ipad.*chrome|chrome.*ipad/i.test(navigator.userAgent)
}

MobileModalShare.prototype.init = function () {
  // Cache selectors
  this.$modalShare = $(this.config.el)
  this.$overlay = this.$modalShare.find(".share-overlay")
  this.$shareList = this.$modalShare.find(".mobile-share-list")
  this.$linkShare = this.$modalShare.find(".link-share")

  this.gaCategory = this.$modalShare.data("ga")

  this.bindModalEvents()
  this.bindModalToShareBtns()
  this.populateShareLinks()
  this.applyAppropriateOrientationCSS()
}

MobileModalShare.prototype.getDeviceOrientation = function () {
  let orientation
  if (window.orientation) {
    orientation = window.orientation === 0 ? "portrait" : "landscape"
  } else {
    let width = window.innerWidth || screen.width
    let height = window.innerHeight || screen.height
    orientation = width > height ? "landscape" : "portrait"
  }
  return orientation
}

MobileModalShare.prototype.open = function () {
  this.gaTracking("open")
  this.$modalShare.fadeIn()
  $("body").addClass("no_scroll")
}

MobileModalShare.prototype.close = function () {
  this.gaTracking("close")
  this.$modalShare.fadeOut()
  $("body").removeClass("no_scroll")
}

// Populate the share links
MobileModalShare.prototype.populateShareLinks = function () {
  if (!this.isIpadAndChrome()) {
    $.each(this.$shareList.find("li > a"), function () {
      $(this).attr("href", $(this).data("url"))
    })
  }
}

MobileModalShare.prototype.gaTracking = function (action, value) {
  if (value) {
    let _gaq = window._gaq || []
    action = "mobile_" + action
    _gaq.push(["_trackEvent", this.gaCategory, action, value])
  }
}

MobileModalShare.prototype.viralshareTracking = function (slideshowId, network) {
  if (slideshowId && network) {
    $.get("account/get_form_authenticity_token").done(function (resp) {
      $.post("/share/viralshare", {
        data: {
          id: slideshowId,
          network: network,
        },
        authenticity_token: resp.auth_token,
      })
    })
  }
}

MobileModalShare.prototype.repositionShareModal = function () {
  this.$overlay.css("position", "static")
}

MobileModalShare.prototype.applyAppropriateOrientationCSS = function () {
  this.orientation = this.getDeviceOrientation()
  if (this.orientation === "portrait") {
    this.$modalShare.removeClass("landscape")
  } else {
    this.$modalShare.addClass("landscape")
  }
}

MobileModalShare.prototype.trackShareEvent = function (options) {
  let config = options || {},
    isEmbed = config.isEmbed || false,
    isOwner =
      (config.entityAuthorId &&
        window.slideshare_object.user &&
        config.entityAuthorId === window.slideshare_object.user.id) ||
      false

  this.shareTracker.shareSlideShow({
    entityId: config.entityId,
    shareType: config.shareType,
    isOwner: isOwner,
    isEmbed: isEmbed,
  })
}

MobileModalShare.prototype.bindModalEvents = function () {
  let that = this

  // Track mobile share options
  this.$shareList.on("click", "li", function () {
    that.gaTracking("social", $(this).data("ga"))

    that.trackShareEvent({
      entityId: that.data.ssId,
      shareType: $(this).data("ga"),
      entityAuthorId: that.data.authorId,
      isEmbed: false,
    })
  })

  // Track viralshare
  if (window.slideshare_mobile_object) {
    that.$shareList.data("slideshow-id", window.slideshare_mobile_object.slideshow.slideshowId)
  }
  this.$shareList.on("click", "[data-network]", function () {
    that.viralshareTracking(that.$shareList.data("slideshow-id"), $(this).data("network"))
  })

  // Quick fix for ipad chrome slideview issue, which doesn't open the link in a new tab.
  if (typeof $mainNav === "undefined" && this.isIpadAndChrome()) {
    this.$shareList.on("click", "a", function () {
      window.open($(this).data("url"), "_blank")
    })
  }

  // Modal close
  this.$modalShare.find(".j-close").on("click", function () {
    that.close()
  })

  this.$modalShare.find(".share-overlay").on("click", function () {
    that.close()
  })

  $(window).on("resize orientationchange", function () {
    that.applyAppropriateOrientationCSS()
  })
}

MobileModalShare.prototype.bindModalToShareBtns = function () {
  let that = this

  // Bind ALL the share buttons to open modal
  $(this.config.parentEl).on("click", this.config.shareBtn, function () {
    let $slideshowItem = $(this).closest(".iso_slideshow"),
      $slideshow = $slideshowItem.length ? $slideshowItem : $(".mobile-swipe-wrapper").find(".player"),
      ssId = $slideshow.data("slideshowid"),
      data

    // If slideshowId found, then get share info for slideshow to populate modal
    if (ssId) {
      data = {
        ssId: $slideshow.data("slideshowid"),
        authorId: $slideshow.data("slideshowauthorid"),
        ssLink: $slideshow.data("sslink"),
        social: {
          linkedin: $slideshow.data("linkedinshareurl"),
          facebook: $slideshow.data("facebookshareurl"),
          twitter: $slideshow.data("twittershareurl"),
          sms: $slideshow.data("smsshareurl"),
          whatsapp: $slideshow.data("whatsappshareurl"),
          email: $slideshow.data("emailshareurl"),
          pinterest: $slideshow.data("pinterestshareurl"),
        },
      }
      that.data = data
    }

    if (ssId) {
      let linkedInShareURL = data.social.linkedin,
        facebookShareURL = data.social.facebook,
        twitterShareURL = data.social.twitter,
        emailShareURL = data.social.email,
        smsShareURL = data.social.sms,
        whatsAppShareURL = data.social.whatsapp,
        pinterestShareURL = data.social.pinterest

      that.$linkShare.attr("href", data.ssLink)
      that.$linkShare.html(data.ssLink)
      that.$shareList.find(".li-share-btn > a").attr("href", linkedInShareURL)
      that.$shareList.find(".fb-share-btn > a").attr("href", facebookShareURL)
      that.$shareList.find(".tw-share-btn > a").attr("href", twitterShareURL)
      that.$shareList.find(".whatsapp-share-btn > a").attr("href", whatsAppShareURL)
      that.$shareList.find(".email-share-btn > a").attr("href", emailShareURL)
      that.$shareList.find(".sms-share-btn > a").attr("href", smsShareURL)
      that.$shareList.find(".pinterest-share-btn > a").attr("href", pinterestShareURL)
      that.$shareList.data("slideshow-id", ssId)

      that.open()
    }
  })
}

export default MobileModalShare
